import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';

const LazyAddServiceTeamMembersDrawer = React.lazy(
	() => import('../components/AddServiceTeamMembersDrawer')
);

export const AddServiceTeamMembersDrawer: React.FC<
	OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:service-team:add-members'>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	return (
		<React.Suspense
			fallback={<div data-testid="loading-add-service-team-members-drawer" />}
		>
			<LazyAddServiceTeamMembersDrawer
				initialParameters={{
					piral,
					cancelInteraction,
					completeInteraction,
					existingMembers: options?.existingMembers,
				}}
			/>
		</React.Suspense>
	);
};
